import * as React from "react";

import { Link, useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Select from "../../Components/Select";
import Button from "../../Components/Button";
import Paper from "../../Components/Paper";
import CountrySelect from "./CountrySelect";
import Dropzone from "../../Components/Dropzone";
import NotFinishedContracts from "../../ListSelect/NotFinishedContracts";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./AddRequestLeaveTerritory.scss";

const initialFormState = {
  contract_number: "",
  registration_number: "",
  country_id: "",
  carte_grise: [],
  quittance: [],
  passeport: [],
  start_date: "",
  motive: "",
  equipment_type: "",
  last_registration_number: "",
  first_registration_number: "",
};

const AddRequestLeaveTerritory = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    let errorMessage = "";
    if (key === "registration_number") {
      const regex = new RegExp("^[A-Z0-9]+$");
      if (!regex.test(val)) {
        errorMessage =
          "Veuillez saisir uniquement des lettres majuscules et des chiffres.";
      }
    }
    if (key === "equipment_type") {
      if (val === "1") {
        setValRegister((prev) => ({ ...prev, registration_number: "" }));
      }
      if (val === "2") {
        setValRegister((prev) => ({
          ...prev,
          first_registration_number: "",
          last_registration_number: "",
        }));
      } else {
        setValRegister((prev) => ({
          ...prev,
          first_registration_number: "",
          last_registration_number: "",
          registration_number: "",
        }));
      }
    }

    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: errorMessage,
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  // const handleChangeField = (e, key) => {
  //   setFormErrorMessages((prev) => ({
  //     ...prev,
  //     [key]: "",
  //   }));

  //   setValRegister((prev) => ({
  //     ...prev,
  //     [key]: e.target.value,
  //   }));
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}/authorization-leave-territory-requests`,
        {
          contract_number: valRegister.contract_number,
          registration_number: valRegister.registration_number,
          country_id: valRegister.country_id,
          quittance: valRegister.quittance,
          carte_grise: valRegister.carte_grise,
          passeport: valRegister.passeport,
          start_date: valRegister.start_date,
          motive: valRegister.motive,
          equipment_type: valRegister.equipment_type,
          last_registration_number: valRegister.last_registration_number,
          first_registration_number: valRegister.first_registration_number,
        },
        {
          timeout: 50000,
        }
      )
      .then((response) => {
        setIsLoading(false);
        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/list-authorization-leave-territory");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };
  return (
    <>
      <div className="back-home">
        <Link to="/list-authorization-leave-territory" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Demandes d’autorisation de quitter le territoire</h1>
      <h6 class="warning-text">Cette prestation vous sera facturée <strong>251 DT TTC</strong>.<br />Montant à régler au moment de la délivrance de l'autorisation de sortie.</h6>
      <p>Veuillez remplir les champs ci dessous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <NotFinishedContracts
            label="Numéro de contrat"
            id="contract_number"
            value={valRegister.contract_number || ""}
            onChange={(e) =>
              handleChangeField(e.target.value, "contract_number")
            }
            required
            hasError={formErrorMessages.contract_number}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.contract_number}
              </div>
            }
          ></NotFinishedContracts>

          <Select
            label="Type matériel"
            id="equipment_type"
            value={valRegister.equipment_type || ""}
            onChange={(e) =>
              handleChangeField(e.target.value, "equipment_type")
            }
            required
            hasError={formErrorMessages.equipment_type}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.equipment_type}
              </div>
            }
          >
            <option value="">--</option>
            <option value="1">Matériel Roulant</option>
            <option value="2">Autre</option>
          </Select>

          {valRegister.equipment_type === "1" && (
            <div className="wrap-immatriculation">
              <Textfield
                label="Série"
                name="first_registration_number"
                placeholder="XXX"
                id="first_registration_number"
                value={valRegister.first_registration_number || ""}
                onChange={(e) =>
                  handleChangeField(e.target.value, "first_registration_number")
                }
                maxLength="3"
                pattern="\d{3}"
                type="text"
                required
                hasError={formErrorMessages.first_registration_number}
                errorMessage={
                  <div className="text-danger">
                    {formErrorMessages.first_registration_number}
                  </div>
                }
              />
              <span className="caption-immatriculation">TU تونس</span>
              <Textfield
                label="N°"
                name="last_registration_number"
                placeholder="XXXX"
                id="last_registration_number"
                value={valRegister.last_registration_number || ""}
                onChange={(e) =>
                  handleChangeField(e.target.value, "last_registration_number")
                }
                maxLength="4"
                pattern="\d{4}"
                type="text"
                required
                hasError={formErrorMessages.last_registration_number}
                errorMessage={
                  <div className="text-danger">
                    {formErrorMessages.last_registration_number}
                  </div>
                }
              />
            </div>
          )}
          {valRegister.equipment_type === "2" && (
            <Textfield
              autoComplete="off"
              label="Immatriculation"
              name="registration_number"
              placeholder=""
              size="large"
              id="registration_number"
              value={valRegister.registration_number || ""}
              onChange={(e) =>
                handleChangeField(e.target.value, "registration_number")
              }
              type="text"
              required
              hasError={formErrorMessages.registration_number}
              errorMessage={
                <div className="text-danger">
                  {formErrorMessages.registration_number}
                </div>
              }
            />
          )}
          <Dropzone
            label="Carte grise (à importer)"
            name="carte_grise"
            hasError={formErrorMessages.carte_grise}
            errorMessage={
              <div className="text-danger">{formErrorMessages.carte_grise}</div>
            }
            value={valRegister.carte_grise || []}
            onChange={(files) => handleChangeField(files, "carte_grise")}
            accept="image/*,.pdf"
            required
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />
          <Dropzone
            label="Quittance de l'assurance (à importer)"
            name="quittance"
            hasError={formErrorMessages.quittance}
            errorMessage={
              <div className="text-danger">{formErrorMessages.quittance}</div>
            }
            value={valRegister.quittance || []}
            onChange={(files) => handleChangeField(files, "quittance")}
            accept="image/*,.pdf"
            required
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />
          <Dropzone
            label="Passeport (à importer)"
            name="passeport"
            hasError={formErrorMessages.passeport}
            errorMessage={
              <div className="text-danger">{formErrorMessages.passeport}</div>
            }
            value={valRegister.passeport || []}
            onChange={(files) => handleChangeField(files, "passeport")}
            accept="image/*,.pdf"
            required
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />
          <Textfield
            autoComplete="off"
            label="Date de départ"
            name="start_date"
            type="date"
            size="large"
            required
            value={valRegister.start_date}
            onChange={(e) => handleChangeField(e.target.value, "start_date")}
            hasError={formErrorMessages.start_date}
            errorMessage={
              formErrorMessages.start_date && (
                <div className="text-danger">{formErrorMessages.start_date}</div>
              )
            }
          />
          <CountrySelect
            label="Pays de destination"
            name="country_id"
            id="country_id"
            value={valRegister.country_id || ""}
            onChange={(e) => handleChangeField(e.target.value, "country_id")}
            required
            hasError={formErrorMessages.country_id}
            errorMessage={
              <div className="text-danger">{formErrorMessages.country_id}</div>
            }
          ></CountrySelect>

          <Textfield
            autoComplete="off"
            label="Motif"
            name="motive"
            type="text"
            placeholder="Veuillez insérer votre Motif"
            size="large"
            value={valRegister.motive}
            onChange={(e) => handleChangeField(e.target.value, "motive")}
            required
            hasError={formErrorMessages.motive}
            errorMessage={
              formErrorMessages.motive && (
                <div className="text-danger">{formErrorMessages.motive}</div>
              )
            }
          />

          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default AddRequestLeaveTerritory;
